<!-- Popup Đổi số tài khoản -->
<div class="popup-overlay-bottom" *ngIf="isChangeAccountPopupVisible">
  <div class="popup-container-account">
    <div class="popup-header-account">
      <h2 class="popup-title-account">Đổi số tài khoản</h2>
      <button class="close-popup-btn" (click)="closeChangeAccountPopup()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <!-- Tài khoản hiện tại - cố định -->
      <div class="popup-body-fixed">
        <p class="section-label">Tài khoản hiện tại</p>
        <div class="account-current">
          <div class="bank-logo">
            <img src="assets/images/mb-bank-logo.png" alt="MB Bank" />
          </div>
          <div class="account-info">
            <span class="account-type">
              {{
                selectedShop?.customer_type === "CN"
                  ? "CÁ NHÂN"
                  : "HỘ KINH DOANH"
              }}
            </span>
            <span class="account-name">
              {{ selectedShop?.terminal_bank_name }} -
              {{ selectedShop?.terminal_bank_acc_name }}
            </span>
            <span class="account-number">{{
              selectedShop?.terminal_bank_acc
            }}</span>
          </div>
        </div>
        <p class="section-label mt-3">Chọn tài khoản mới</p>
      </div>

      <!-- Phần cuộn -->
      <div class="popup-body-scroll">
        <!-- Skeleton loading khi đang tải tên chủ tài khoản -->
        <ng-container *ngIf="isLoadingOwners">
          <div class="account-option skeleton-row" *ngFor="let i of [1, 2, 3]">
            <div class="account-info">
              <span class="skeleton skeleton-type"></span>
              <span class="skeleton skeleton-name"></span>
              <span class="skeleton skeleton-number"></span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!isLoadingOwners">
          <div
            *ngFor="let account of dataUser"
            class="account-option"
            [class.selected]="
              selectedNewAccount?.account_number === account.account_number
            "
            (click)="selectNewAccount(account)"
          >
            <div class="account-info">
              <span class="account-type2">{{ account.account_type }}</span>
              <span class="account-name">{{ account.account_owner }}</span>
              <span class="account-number">{{ account.account_number }}</span>
            </div>
            <div class="radio-circle">
              <div
                class="radio-inner"
                *ngIf="
                  selectedNewAccount?.account_number === account.account_number
                "
              ></div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Cảnh báo -->
      <div
        class="warning-box"
        [ngClass]="
          needRegenerateQr ? 'warning-box-danger' : 'warning-box-success'
        "
      >
        <p class="warning-text" *ngIf="needRegenerateQr">
          Sau khi đổi tài khoản, vui lòng in và dán mã QR mới lên loa thanh toán
        </p>
        <p class="warning-text-success" *ngIf="!needRegenerateQr">
          Không cần thay đổi hoặc in lại mã QR trên loa thanh toán sau khi đổi
          tài khoản
        </p>
      </div>
    </div>

    <div class="popup-footer-account">
      <button
        class="btn-mb p-3 rounded-4 w-100"
        [disabled]="
          !selectedNewAccount ||
          isSameAccount ||
          isCheckingQr ||
          isLoadingOwners ||
          isSubmitting
        "
        (click)="openGuidePopup()"
      >
        <ng-container *ngIf="!isCheckingQr && !isSubmitting; else loadingBtn">
          Tiếp tục
        </ng-container>
        <ng-template #loadingBtn>
          <span class="spinner-border spinner-border-sm me-2"></span>
          <span *ngIf="isCheckingQr">Đang kiểm tra...</span>
          <span *ngIf="isSubmitting">Đang xử lý...</span>
        </ng-template>
      </button>
    </div>
  </div>
</div>

<!-- Popup Hướng dẫn cập nhật mã QR -->
<div class="guide-overlay" *ngIf="isGuidePopupVisible">
  <div class="guide-container">
    <!-- Header -->
    <div class="guide-header">
      <h2 class="guide-title">Hướng dẫn cập nhật mã QR</h2>
      <button class="close-popup-btn" (click)="closeGuidePopup()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Slider content -->
    <div class="guide-slides-wrapper">
      <div
        class="guide-slides"
        [style.transform]="'translateX(-' + currentStep * 100 + '%)'"
      >
        <!-- Step 1: Lấy QR trên loa -->
        <div class="guide-slide">
          <div class="step-badge">1/3</div>
          <p class="step-title">Lấy QR trên loa</p>
          <p class="step-desc">
            Tại hàn hình thống báo thành công, nhấn lấy QR trên loa
          </p>
          <img
            src="assets/images/guide-step1.png"
            alt="Chụp màn hình mã QR mới"
            style="
              width: 90%;
              height: auto;
              border-radius: 12px;
              object-fit: contain;
            "
            onerror="this.style.display = 'none'"
          />
        </div>

        <!-- Step 2: Chụp màn hình mã QR mới -->
        <div class="guide-slide">
          <div class="step-badge">2/3</div>
          <p class="step-title">Chụp màn hình mã QR mới</p>
          <p class="step-desc">
            Mã QR sẽ hiển thị trên màn hình. Bạn chụp màn hình hoặc lưu lại
          </p>
          <img
            src="assets/images/guide-step2.png"
            alt="Chụp màn hình mã QR mới"
            style="
              width: 60%;
              height: auto;
              border-radius: 12px;
              object-fit: contain;
            "
            onerror="this.style.display = 'none'"
          />
        </div>

        <!-- Step 3: In và dán mã QR lên loa -->
        <div class="guide-slide">
          <div class="step-badge">3/3</div>
          <p class="step-title">In và dán mã QR lên<br />loa thanh toán</p>
          <p class="step-desc">
            In mã QR vừa chụp và dán lên loa để tiếp tục nhận giao dịch
          </p>
          <img
            src="assets/images/guide-step3.png"
            alt="Chụp màn hình mã QR mới"
            style="
              width: 100%;
              height: auto;
              border-radius: 12px;
              object-fit: contain;
            "
            onerror="this.style.display = 'none'"
          />
        </div>
      </div>
    </div>

    <!-- Dots indicator -->
    <div class="guide-dots">
      <span
        class="guide-dot"
        [class.active]="currentStep === 0"
        (click)="goToStep(0)"
      ></span>
      <span
        class="guide-dot"
        [class.active]="currentStep === 1"
        (click)="goToStep(1)"
      ></span>
      <span
        class="guide-dot"
        [class.active]="currentStep === 2"
        (click)="goToStep(2)"
      ></span>
    </div>

    <!-- Footer button -->
    <div class="guide-footer">
      <button
        class="btn-mb p-3 rounded-4 w-100"
        [disabled]="isSubmitting"
        (click)="currentStep < 2 ? nextStep() : confirmChangeAccount()"
      >
        <ng-container *ngIf="!isSubmitting; else loadingGuideBtn">
          {{ currentStep < 2 ? "Tiếp theo" : "Tôi đã hiểu" }}
        </ng-container>
        <ng-template #loadingGuideBtn>
          <span class="spinner-border spinner-border-sm me-2"></span> Đang xử
          lý...
        </ng-template>
      </button>
    </div>
  </div>
</div>
